import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 4.233 1.058" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.117 1.058a.53.53 0 100-1.058.53.53 0 000 1.058zM.53 1.058A.53.53 0 10.53 0a.53.53 0 000 1.058zM3.704 1.058a.53.53 0 100-1.058.53.53 0 000 1.058z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }